<template>
    <div class="min-h-screen bg-[#F7F7F9] font-sans text-[#111]">

        <!-- <header class="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-xl border-b border-gray-100">
            <div class="flex items-center justify-between px-6 py-3.5">
                <div class="flex items-center gap-4">
                    <button class="p-2 rounded-lg text-black hover:bg-gray-100 md:hidden transition-colors" @click="sidebarOpen = true">
                        <i class="fas fa-bars text-lg"></i>
                    </button>
                    <div class="flex items-center gap-3 cursor-pointer" onclick="window.location.href='/app'">
                        <img src="https://storage.victoranw.fr/file/hGf4I3ecnS" class="h-9" alt="TermoFlow">
                        <span class="font-black text-xl tracking-tighter text-black">TermoFlow</span>
                    </div>
                </div>
                <div class="flex items-center gap-3">
                    <div class="px-4 py-1.5 rounded-full bg-gradient-to-r from-orange-500 to-red-500 text-white text-xs font-bold uppercase tracking-wide shadow-sm shadow-orange-200">
                        <i class="fas fa-briefcase mr-1.5 text-[10px]"></i>Espace Commercial
                    </div>
                </div>
            </div>
        </header> -->

        <div v-if="sidebarOpen" class="fixed inset-0 bg-black/40 backdrop-blur-sm z-40 md:hidden" @click="sidebarOpen = false"></div>

        <aside
            class="fixed top-0 left-0 z-50 h-screen w-[270px] bg-white border-r border-gray-100 transform transition-transform duration-300 md:translate-x-0"
            :class="sidebarOpen ? 'translate-x-0' : '-translate-x-full'">

            <div class="h-full flex flex-col">
                <div class="p-5 pb-3 border-b border-gray-50">
                    <div class="flex items-center gap-2.5">
                        <img src="https://storage.victoranw.fr/file/hGf4I3ecnS" class="h-7" alt="TermoFlow">
                        <span class="text-xl tracking-tighter font-black text-black">TermoFlow</span>
                    </div>
                </div>

                <nav class="flex-1 overflow-y-auto px-3 py-4 space-y-0.5">

                    <div class="px-3 mb-2">
                        <span class="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Principal</span>
                    </div>

                    <a href="/commercial" class="group flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-150"
                        :class="currentRouteKey === 'dashboard' ? 'bg-gradient-to-r from-orange-500 to-red-500 text-white font-semibold shadow-sm shadow-orange-200' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900'">
                        <i class="fas fa-chart-pie text-sm w-4 text-center" :class="currentRouteKey === 'dashboard' ? 'text-white' : 'text-gray-400 group-hover:text-gray-700'"></i>
                        <span class="text-sm">Tableau de bord</span>
                    </a>

                    <div class="px-3 mb-2 mt-4">
                        <span class="text-[10px] font-bold text-gray-400 uppercase tracking-widest">CRM</span>
                    </div>

                    <a href="/commercial/prospects" class="group flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-150"
                        :class="currentRouteKey === 'prospects' ? 'bg-gradient-to-r from-orange-500 to-red-500 text-white font-semibold shadow-sm shadow-orange-200' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900'">
                        <i class="fas fa-columns text-sm w-4 text-center" :class="currentRouteKey === 'prospects' ? 'text-white' : 'text-gray-400 group-hover:text-gray-700'"></i>
                        <span class="text-sm">Suivi prospect</span>
                        <span v-if="prospectCount" class="ml-auto text-[10px] font-bold px-2 py-0.5 rounded-full"
                            :class="currentRouteKey === 'prospects' ? 'bg-white/25 text-white' : 'bg-orange-100 text-orange-600'">
                            {{ prospectCount }}
                        </span>
                    </a>

                    <a href="/commercial/clients" class="group flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-150"
                        :class="currentRouteKey === 'clients' ? 'bg-gradient-to-r from-orange-500 to-red-500 text-white font-semibold shadow-sm shadow-orange-200' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900'">
                        <i class="fas fa-building text-sm w-4 text-center" :class="currentRouteKey === 'clients' ? 'text-white' : 'text-gray-400 group-hover:text-gray-700'"></i>
                        <span class="text-sm">Mes clients</span>
                    </a>

                </nav>

                <div class="border-t border-gray-100">
                    <div class="p-3 border-b border-gray-100">
                        <button v-if="$account.account.super_admin || $account.account.commercial" @click="$router.push({name: 'ChooseSpace'})"
                            class="flex items-center gap-2 bg-purple-50 border border-purple-200 text-purple-700 text-xs font-semibold px-3 py-1.5 rounded-md hover:bg-purple-100 transition-colors">
                            <i class="fas fa-share text-xs"></i> Changer d'espace
                        </button>
                    </div>
                    <div @click="logout" class="flex items-center gap-3 p-3 rounded-xl border border-transparent hover:border-gray-100 hover:bg-gray-50 transition cursor-pointer group">
                        <div class="relative">
                            <div class="w-8 h-8 rounded-full bg-gradient-to-br from-orange-500 to-red-500 text-white flex items-center justify-center font-bold text-xs ring-2 ring-orange-100">
                                {{ ($account.account.prenom.charAt(0) + $account.account.nom.charAt(0)).toUpperCase() }}
                            </div>
                            <div class="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 bg-green-400 border-2 border-white rounded-full"></div>
                        </div>
                        <div class="flex-1 overflow-hidden">
                            <div class="text-sm font-semibold text-gray-900 truncate">{{ $account.account.prenom }} {{ $account.account.nom }}</div>
                            <div class="text-[10px] text-orange-500 font-semibold uppercase tracking-wide">Commercial</div>
                        </div>
                        <i class="fas fa-sign-out-alt text-xs text-gray-300 group-hover:text-red-400 transition-colors"></i>
                    </div>
                </div>
            </div>
        </aside>

        <main class="-pt-1 md:pl-[270px] min-h-[calc(100vh-61px)]">
            <slot></slot>
        </main>
    </div>
</template>

<script>
export default {
    name: 'CommercialTemplate',
    props: {
        prospectCount: { default: null }
    },
    data() {
        return { sidebarOpen: false }
    },
    computed: {
        currentRouteKey() {
            const map = {
                CommercialDashboard: 'dashboard',
                SuiviProspect: 'prospects',
                MesClients: 'clients',
            };
            return map[this.$route.name] || '';
        }
    },
    methods: {
        logout() {
            localStorage.removeItem('auth-token');
            window.location.href = '/login';
        }
    }
}
</script>